import React, {useState} from 'react';
import {ERROR} from '@di-shared/const';
import DailyLineGraph from '@di-shared/features/common/DailyLineGrpah';
import {formatNumberWithCommas} from '@di-shared/utils';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';
import useUnitConverter from '@di-shared/utils/useUnitConverter';

interface EnergyMileageDailyGraphProps {
  data: Array<{
    score: number;
    scoreDate: Date;
  }>;
  error?: boolean;
}

export default function EnergyMileageDailyGraph({data, error = false}: EnergyMileageDailyGraphProps) {
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  const [selectedDataIndex, setSelectedDataIndex] = useState<number>(data.length - 1);
  const {defaultEnergyEfficiencySymbol, convertEnergyEfficiencySymbol, convertEnergyEfficiencyValue} = useUnitConverter();

  function getTooltipText(selectedDataIndex: number) {
    const selectedScoreDate = data[selectedDataIndex].scoreDate;
    return error
      ? `${CldrDatetimeFormatter.format(selectedScoreDate, 'MMMd')}┃${ERROR.DASH}${defaultEnergyEfficiencySymbol}`
      : `${CldrDatetimeFormatter.format(selectedScoreDate, 'MMMd')}┃${formatNumberWithCommas(convertEnergyEfficiencyValue(data[selectedDataIndex].score, {skipFormatting: true}))}${convertEnergyEfficiencySymbol(data[selectedDataIndex].score, {skipFormatting: true})}`;
  }

  return (
    <DailyLineGraph
      data={data.map(({score, ...others}) => ({score: +convertEnergyEfficiencyValue(score, {skipFormatting: true}), ...others}))}
      labels={data.map((dataItem) => dataItem.scoreDate)}
      options={{
        tooltip: {
          isShow: true,
          tooltipText: getTooltipText(selectedDataIndex),
        },
      }}
      interactions={{
        selectedDataIndex,
        onUpdateSelectedDataIndex: setSelectedDataIndex,
      }}
    />
  );
}
